import * as net from 'util/Net';

export function redeemPromoCode(code: string): Promise<{}> {
  return net.postJSONPromise({
    url: '/1/api/promo-codes:redeem',
    data: {code},
  });
}
